import api from 'api';

export const getMonitorItems = (params) => {
  return api.get('/monitor_items', params, 'bearer');
};

export const getMonitorItem = (id, params) => {
  return api.get(`/monitor_items/${id}`, params, 'bearer');
};

export const createMonitorItem = (body) => {
  return api.post('/monitor_items', body, 'bearer');
};

export const updateMonitorItem = (id, body) => {
  return api.put(`/monitor_items/${id}`, body, 'bearer');
};

export const deleteMonitorItem = (id) => {
  return api.delete(`/monitor_items/${id}`, 'bearer');
};

export const getModels = (params) => {
  return api.get('/models', params, 'bearer');
};

export const getModel = (id, params) => {
  return api.get(`/models/${id}`, params, 'bearer');
};

export const createModel = (body) => {
  return api.post('/models', body, 'bearer');
};

export const updateModel = (id, body) => {
  return api.put(`/models/${id}`, body, 'bearer');
};

export const getUserProducts = (params) => {
  return api.get('/user_products', params, 'bearer');
};

export const getMergedUserProducts = (params) => {
  return api.get('/merged_user_products', params, 'bearer');
};

export const getBrands = (params) => {
  return api.get('/brands', params, 'bearer');
};

export const getBrand = (id, params) => {
  return api.get(`/brands/${id}`, params, 'bearer');
};

export const updateBrand = (id, body) => {
  return api.put(`/brands/${id}`, body, 'bearer');
};

export const createBrand = (body) => {
  return api.post('/brands', body, 'bearer');
};

export const getSources = (params) => {
  return api.get('/sources', params, 'bearer');
};

export const getContact = (id, params) => {
  return api.get(`/contacts/${id}`, params, 'bearer');
};

export const updateContact = (id, body) => {
  return api.put(`/contacts/${id}`, body, 'bearer');
};

export const createContact = (body) => {
  return api.post('/contacts', body, 'bearer');
};

export const getAlert = (id, params) => {
  return api.get(`/alerts/${id}`, params, 'bearer');
};

export const updateUserProducts = () => {
  return api.put('/update_user_products', null, 'bearer');
};

export const importModelCsv = (body) => {
  return api.postMultipart('/import_models', body, 'bearer');
};
